export const pivotStyles = {
	header: {
		backgroundColor: '#132547',
	},
	sidebar: {
		backgroundColor: '#154a6d',
		color: 'white',
	},
	button: {
		backgroundColor: '#ffbc43',
		color: '#132547',
		border: '1px solid #000',
		fontWeight: 600,
		':hover': {
			color: '#fff',
			backgroundColor: '#132547',
			borderColor: '#000',
		},
	},
	text: {
		color: '#132547',
		buttonLoadingColor: '#132547',
	},
	title: {
		color: '#fff',
	},
	table: {
		headerBackgroundColor: '#00a7cf',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Pivot Parking Platform',
	},
	logo: {
		small: {
			src: '/pivotParking/pivot-parking-icon.svg',
			height: 35,
			width: 35,
		},
		large: {
			src: '/pivotParking/pivot-parking-logo.svg',
			height: 60,
			width: 60,
		},
	},
	favicon: {
		src: '/pivotParking/pivot-parking-icon.svg',
	},
	socials: {
		instagram: 'https://instagram.com/pivotparkingllc',
		linkedIn: 'https://www.linkedin.com/company/pivot-parking/',
	},
	siteUrl: 'https://pivotparking.com/',
	orgName: 'Pivot Parking',
};
